import React from "react";
import RecipeList from "../components/Recipes/RecipeList";

const RecipesPage = () => {
    return (
        <div>
            <h2>🍽️ Recepty</h2>
            <RecipeList />
        </div>
    );
};

export default RecipesPage;
